// src/layouts/CleanLayout.tsx
import React from 'react';
import { Outlet } from 'react-router-dom';

const CleanLayout: React.FC = () => {
  // Outlet renderiza a página filha da rota
  return <Outlet />;
};

export default CleanLayout;
